module.exports = __webpack_public_path__ + "media/partners/warc-94301ed0.png";